import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import {
  IGlobalCompaniesState,
  IGlobalCompanyContactsState,
  IGlobalGroupsState,
  IGlobalSocialNetworksState,
  selectCompanyContacts,
  selectCompanyList,
  selectGroups,
  selectSocialNetworks,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import ConnectionEditPage from '../components/ConnectionEditPage'
import {
  actionCreators,
  IConnectionEditState,
  selectCanSave,
  selectConnection,
  selectSelectedConnections,
} from '../modules/connectionEdit'

type IComponentState = IConnectionEditState &
  ICurrentUserState &
  IGlobalCompanyContactsState &
  IGlobalSocialNetworksState &
  IGlobalGroupsState &
  IGlobalCompaniesState

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IComponentState>({
      canSave: selectCanSave(),
      companies: selectCompanyList(),
      companyContacts: selectCompanyContacts(),
      connection: selectConnection(),
      groups: selectGroups(),
      selectedConnections: selectSelectedConnections(),
      socialNetworks: selectSocialNetworks(),
      user: selectCurrentUser(),
    }),
    actionCreators,
  )(ConnectionEditPage),
)
